import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moving-in-path',
  templateUrl: './moving-in-path.component.html',
  styleUrls: ['./moving-in-path.component.scss']
})
export class MovingInPathComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
